import React, { Component } from "react";
import AlarmRulesComponent from "../components/alarmRulesComponent";
import {
  getAllRegionSettings,
  getAllAlarmRules,
  editAlarmRule,
  editGetLifeguardPerformedDefibrillatorCpr,
  getLifeguardPerformedDefibrillatorCpr1
} from "../action/alarmRulesAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

export class AlarmRulesContainer extends Component {
  constructor(props) {
    super(props);
    
  }
  componentDidMount() {
    //this.props.actions.getAllAlarmRules();
    this.props.actions.getAllRegionSettings().then(res => {
            console.log('f', res)
           
         this.props.actions.getLifeguardPerformedDefibrillatorCpr1({RegionId:res.regionList[0].ID});

        });
  }
  getUserList = (data) => {
    this.props.actions.getAllAlarmRules(data, this.props.dispatch).then(res => {
            console.log('f', res)
           
         this.props.actions.getLifeguardPerformedDefibrillatorCpr1(data);

        });;
  };
  getRegionData = () => {
    this.props.actions.getAllRegionSettings(this.props.dispatch);
  };
  getRules = () => {
    this.props.actions.getAllAlarmRules(this.props.dispatch);
  };
  editRule = (data) => {
    this.props.actions.editAlarmRule(data, this.props.dispatch);
  };

   getlifeguardPerformedDefibrillator = () => {
   // this.props.actions.getLifeguardPerformedDefibrillatorCpr1(this.props.dispatch);
  };
  editlifeguardPerformedDefibrillator= (data) => {
    this.props.actions.editGetLifeguardPerformedDefibrillatorCpr(data, this.props.dispatch);
  };
   getlifeguardPerformedDefibrillatorList = (data) => {
    //this.props.actions.getLifeguardPerformedDefibrillatorCpr1(data, this.props.dispatch);
  };
  render() {
    return (
      <AlarmRulesComponent
        getAlarmRules={this.props.allAlarmRules}
        getAllRules={this.getRules}
        updateRule={this.editRule}
        getRegionList={this.getRegionData}
        getUserList={this.getUserList}

          getlifeguardPerformedDefibrillator={this.getlifeguardPerformedDefibrillator}
        updatelifeguardPerformedDefibrillator={this.editlifeguardPerformedDefibrillator}
        getlifeguardPerformedDefibrillatorList={this.getlifeguardPerformedDefibrillatorList}
      ></AlarmRulesComponent>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    actions: bindActionCreators(
      {
        getAllAlarmRules,
        editAlarmRule,
        getAllRegionSettings,
        editGetLifeguardPerformedDefibrillatorCpr,
getLifeguardPerformedDefibrillatorCpr1
      },
      dispatch
    ),
  };
}
function mapStateToProps({ AlarmRulesReducer }) {
  console.log(AlarmRulesReducer);
  return {
    allAlarmRules: {
      errorCode: AlarmRulesReducer.errorCode,
      statusCode: AlarmRulesReducer.statusCode,
      alarmRules: AlarmRulesReducer.alarmRules,
      message: AlarmRulesReducer.message,
      updatedList: AlarmRulesReducer.updatedList,
      regionList: AlarmRulesReducer.regionList,
      lifeguardPerformedDefibrillator:AlarmRulesReducer.lifeguardPerformedDefibrillator

    },
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AlarmRulesContainer)
);
